var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"relative"},[_c('div',{staticClass:"pb-6 pl-10"},[_c(_vm.is,{tag:"component",attrs:{"entry":_vm.entry,"job-sheet":_vm.jobSheet}}),_vm._v(" "),_c('files-lists',{staticClass:"mt-4",attrs:{"files":_vm.entry.files.data,"show-empty":false}})],1),_vm._v(" "),_c('div',{staticClass:"absolute border-2 border-l rounded",style:({
            top: '32px',
            left: '10px',
            bottom: '6px'
        })})])}
var staticRenderFns = []

export { render, staticRenderFns }